import React from "react";
import { useTranslation } from "react-i18next";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

export interface IWarningsInfoModal {
	warnings: string[],
	errors: string[],
	callback: () => void,
}

export default function WarningModal(props: { model: IWarningsInfoModal, onClose: () => void }) {
	const { t } = useTranslation();

	return <Dialog
		open={true}
		disableBackdropClick
	>
		<DialogTitle>{t("common.warning")}</DialogTitle>
		<DialogContent>
			<ul>{props.model.errors.map((x, i) => <li key={i}><DialogContentText>{t(x)}</DialogContentText></li>)}</ul>
			<ul>{props.model.warnings.map((x, i) => <li key={i}><DialogContentText>{t(x)}</DialogContentText></li>)}</ul>
			{props.model.errors.length === 0 && <DialogContentText>
				{t("common.message.areYouSureYouWantToContinue")}
			</DialogContentText>}
		</DialogContent>
		<DialogActions>
			<Button onClick={(e) => props.onClose()} color="default" variant="contained">
				{t("common.action.cancel")}
			</Button>
			<Button
				disabled={props.model.errors.length !== 0}
				onClick={(e) => {
					props.onClose();
					props.model.callback();
				}}
				color="secondary"
				variant="contained"
			>
				{t("common.action.continue")}
			</Button>
		</DialogActions>
	</Dialog>
}